import { useNavigate } from "react-router-dom";
import { ListFetch } from "../../lib/typeDeclarations";
import { useListRecords } from "../../server/hooks/getData";
import { useFilters } from "../../lib/setSearchParams";

import Header from "../../components/layout/Header";
import { TextInput } from "../../components/inputs/TextInput";
import { Autocomplete } from "../../components/inputs/Autocomplete";
import { FilterBar, Page, PageBody, PageHeader } from "../../components/layout/Page";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { Loader } from "../../components/loader/Loader";
import { useCallback, useState } from "react";
import { addIcon } from "../../assets/icons";

export default function DeviceList() {
  document.title = "Eszközök";
  const navigate = useNavigate();

  //States

  const headers = ["Típus", "Gyártó", "Megnevezés"];
  const { filters, setFilters } = useFilters();
  const [autocompleteFilters, setAutocompleteFilters] = useState<{ [key: string]: any }>({
    manu: "",
    desc: "",
  });

  const { data: devices, loading }: ListFetch = useListRecords(
    "devices",
    [JSON.stringify(filters)],
    {
      ...filters,
      orderBy: "type",
      order: "ASC",
    }
  );
  //Fetch data
  const manufacturers = useListRecords("devManu", [autocompleteFilters.manu], {
    manufacturer: autocompleteFilters.manu,
    limit: 10,
  });
  const descriptions = useListRecords("devDesc", [autocompleteFilters.desc], {
    description: autocompleteFilters.desc,
    limit: 10,
  });

  const manuFilter = useCallback(
    (item: any) => {
      console.log(autocompleteFilters);
      autocompleteFilters.manu === "" && setFilters(prev => ({ ...prev, manufacturer_id: "" }));
      setFilters(prev => ({ ...prev, manufacturer_id: item.id }));
    },
    [autocompleteFilters.manu]
  );

  const descFilter = (item: any) => {
    console.log(autocompleteFilters);
    setFilters(prev => ({ ...prev, description_id: item.id }));
  };

  //Component
  return (
    <Page>
      <Header
        itemCounter={{
          page: devices.page,
          limit: devices.limit,
          total: devices.total,
          setPage: setFilters,
        }}
      >
        <PrimaryButton
          btn={{ svgBefore: addIcon, text: "Létrehozás", onClick: () => navigate("new") }}
        />{" "}
      </Header>
      <PageHeader title="Eszközök" />
      <FilterBar>
        <TextInput stateKey="type" placeholder="Típus" state={filters} setState={setFilters} />
        <Autocomplete
          state={autocompleteFilters}
          setState={setAutocompleteFilters}
          stateKey="manu"
          list={manufacturers.data.data}
          listKeys={["manufacturer"]}
          handleClick={manuFilter}
          placeholder="Gyártó"
        />
        <Autocomplete
          state={autocompleteFilters}
          setState={setAutocompleteFilters}
          stateKey="desc"
          list={descriptions.data.data}
          listKeys={["description"]}
          handleClick={descFilter}
          placeholder="Megnevezés"
        />
      </FilterBar>
      {!loading ? (
        <>
          <PageBody>
            <div className="listitem">
              <table>
                <thead>
                  <tr>
                    {headers.map(item => (
                      <th key={item}>{item}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {devices.data.length !== 0 ? (
                    devices.data.map(item => (
                      <tr key={item.id} onClick={() => navigate(`${item.id}`)}>
                        <td>{item.type}</td>
                        <td>{item.manufacturer}</td>
                        <td>{item.description}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={headers.length + 1} style={{ textAlign: "center" }}>
                        Nincs találat!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </PageBody>
        </>
      ) : (
        <Loader />
      )}
    </Page>
  );
}
